import React from 'react'

import { Box, Text, Link } from '@clear/design-system'
import { EnrollmentLocation } from '@utils/getNearbyEnrollmentLocations'
import { LaneInfo } from './LaneInfo'
import { useConfigContext } from '@contexts/ConfigContext'
import { ConversionCouponInfo } from './ConversionCouponInfo'

export interface ILocationInfo {
  location: EnrollmentLocation
}

export const LocationInfo = ({ location }: ILocationInfo) => {
  const {
    config: {
      locations: { displayConversionCouponInfo },
    },
  } = useConfigContext()
  return (
    <>
      <Box>
        <Text as="h5" fontSize={4} mb={2}>
          {location?.name}
        </Text>
        <Text fontSize={0} color="neutralsTextGray" display="inline-block">
          {location?.distance} miles away •{' '}
          <Link
            href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURI(
              location.address
            )}`}
            target="_blank"
          >
            {location?.address}
          </Link>
        </Text>
        <br />
        <Text fontSize={0} color="utilityDarkErrorRed">
          {location?.importantInfo}
        </Text>
        <Text
          className="flex flex-col"
          fontSize={0}
          color="neutralsPlaceholderGray"
        >
          {location?.lanes.map(
            (
              {
                name,
                description,
                isAccessible,
                availability,
                accessibilityMessage,
                importantInfo,
                id,
              },
              i
            ) => (
              <LaneInfo
                key={id}
                id={id}
                name={name}
                description={description}
                openDaily={location?.openDaily}
                accessibilityMessage={accessibilityMessage}
                isAccessible={isAccessible}
                availability={availability}
                conversionCouponInfo={location?.conversionCouponInfo || ''}
                importantInfo={importantInfo}
                lastLane={location?.lanes.length - 1 === i}
              />
            )
          )}
          <Text fontSize={0} color="utilityDarkErrorRed">
            {location?.importantInfo}
          </Text>
          {(!location?.lanes || location?.lanes?.length === 0) &&
          location.conversionCouponInfo &&
          displayConversionCouponInfo ? (
            <ConversionCouponInfo
              conversionCouponInfo={location.conversionCouponInfo}
            />
          ) : null}
        </Text>
      </Box>
    </>
  )
}
